import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class FinishCodeReferenceService extends BaseReferenceService {
  constructor() {
    super('FinishCodeReference');
  }
}
